module.exports = __webpack_public_path__ + "media/images/flags/gh-87df1b8604e8b613cc736562d88ffe9a.svg";